import { useNavigate } from "react-router-dom";
import StoryCard from "@/components/feature/StoryCard";
import { STORIES } from "@/mocks/stories";

interface Props {
  keyword: string;
}

export default function SearchPanel({ keyword }: Props) {
  const navigate = useNavigate();
  const kw = keyword.toLowerCase();
  const results = STORIES.filter((s) => {
    const hay = `${s.title}${s.summary}${s.tags.join("")}`.toLowerCase();
    return hay.includes(kw);
  });

  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">搜索结果</h1>
          <p className="mt-2 text-sm text-foreground-600">
            为你找到 <strong className="font-bold text-primary-700">{results.length}</strong> 条与「{keyword}」相关的瓜文
          </p>
        </div>
        <button
          type="button"
          onClick={() => navigate("/")}
          className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-4 py-2 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-arrow-left-line" aria-hidden="true" />
          返回首页
        </button>
      </div>

      {results.length > 0 ? (
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {results.map((s) => (
            <StoryCard key={s.slug} story={s} />
          ))}
        </div>
      ) : (
        <div className="mt-10 rounded-2xl border border-background-300/60 bg-background-100 px-6 py-14 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-2xl text-secondary-700">
            <i className="ri-search-line" aria-hidden="true" />
          </span>
          <h2 className="mt-4 font-heading text-lg font-bold text-foreground-950">暂时没有搜到这颗瓜</h2>
          <p className="mt-2 text-sm text-foreground-600">换个关键词试试，比如「表白」「异地」「冷战」「AA」。</p>
        </div>
      )}
    </section>
  );
}